export default [
  {
    title: 'Softphone',
    route: 'softphone-view',
    icon: 'PhoneCallIcon',
    roles: ['permission.softphone.view']
  }]